import difference from 'lodash/difference';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import Column from 'src/components/10-atoms/layout/Column';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import useCallbackWithCtx from 'src/hooks/useCallbackUtils/useCallbackWithCtx';
import { duplicateRef } from 'src/utils/react';
import TagsInput from '..';
import TagSuggestions from './TagSuggestions';
import useKeyboardNavigation from './useKeyboardNavigation';
const AutoCompleteTagsInput = React.forwardRef(({ suggestions, onChange, onFocus, onBlur, value, onInputChange, inputRef, ...tagsInputProps }, ref) => {
    const [{}] = useTheme();
    const [focused, setFocused] = useState(false);
    const [showSuggestions, setShowSuggestions] = useState(false);
    const filteredSuggestions = useMemo(() => {
        return difference(suggestions, value ?? []);
    }, [suggestions, value]);
    const shouldShowSuggestions = focused &&
        tagsInputProps.input.length >= 1 &&
        filteredSuggestions.length > 0;
    const inputContainerRef = useRef(null);
    const shadowInputRef = useRef(null);
    useEffect(() => {
        setShowSuggestions(shouldShowSuggestions);
    }, [shouldShowSuggestions]);
    const blurTimeoutRef = useRef(undefined);
    const handleFocus = useCallbackWithCtx(ctx => {
        clearTimeout(blurTimeoutRef.current);
        setFocused(true);
        ctx.onFocus?.();
    }, { onFocus });
    const handleBlur = useCallbackWithCtx(ctx => {
        blurTimeoutRef.current = setTimeout(() => {
            setFocused(false);
            ctx.onBlur?.();
        }, 300);
    }, { onBlur });
    const handleChange = useCallbackWithCtx((ctx, newTags) => {
        setShowSuggestions(false);
        ctx.onInputChange('');
        ctx.onChange?.(newTags);
    }, { onChange, onInputChange });
    const handleTagSelected = useCallbackWithCtx((ctx, tag) => {
        handleChange([...ctx.value, tag]);
        shadowInputRef.current?.focus();
    }, { value });
    const [keyboardNavigationState, keyboardNavigationActions] = useKeyboardNavigation({
        data: filteredSuggestions,
        onItemSelected: handleTagSelected,
    });
    return (React.createElement(Column, { ref: ref, style: { position: 'relative' } },
        React.createElement(TagsInput, { ref: inputContainerRef, inputRef: duplicateRef(inputRef, shadowInputRef), value: value, onInputChange: onInputChange, onFocus: handleFocus, onBlur: handleBlur, onChange: handleChange, onKeyPress: keyboardNavigationActions.handleKeyPress, ...tagsInputProps }),
        React.createElement(TagSuggestions, { data: filteredSuggestions, inputContainerRef: inputContainerRef, inputRef: shadowInputRef, selectedTagIndex: keyboardNavigationState.focusedIndex, onTagSelected: handleTagSelected, visible: showSuggestions })));
});
export default AutoCompleteTagsInput;
